<template>
  <v-app class="view">


    <v-dialog
        v-model="EditObjectDialogChooseType"
        max-width="400"
        overlay-opacity="0.8"

    >
      <v-card class="pa-8">
        <v-container>
          <v-row>
            <v-col>
              <v-btn large outlined
                     tile
                     width="100%" @click="newObjectType('S')">
                แพ๊คเกจซื้อเป็นชุด
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn large outlined
                     tile
                     width="100%" @click="newObjectType('D')">
                ผสมคละสินค้า
              </v-btn>
            </v-col>
          </v-row>
<!--          <v-row>-->
<!--            <v-col>-->
<!--              <v-btn large outlined-->
<!--                     tile-->
<!--                     width="100%" @click="newObjectType('T')">-->
<!--                ลดราคา-->
<!--              </v-btn>-->
<!--            </v-col>-->
<!--          </v-row>-->


        </v-container>
        <v-btn class="close-button" color="gray" fab tile @click="EditObjectDialogChooseType=false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="EditObjectDialogStatic"
        max-width="900"
        overlay-opacity="0.8"
        persistent
    >
      <form v-if="selectedObject" @submit.prevent="onSubmitObject">
        <v-card class="pa-8">
          <v-container>
            <v-row>
              <v-col>

                <v-text-field
                    v-model="selectedObject.name"
                    class="dialog-input"
                    hide-details
                    label="ชื่อโปรโมชั่น"
                    outlined
                    placeholder=""
                    required
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                    v-model="selectedObject.amount_limit"
                    class="dialog-input"
                    hide-details
                    :label="`จำกัดจำนวน (ขายแล้ว ${selectedObject.amount_sold})`"
                    outlined
                    placeholder="ไม่จำกัดใส่ 0"
                    required
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>

                <v-simple-table class="itemTable" fixed-header>
                  <template v-slot:default>
                    <thead>
                    <tr class="ItemHead">
                      <th class="text-left">รายการ</th>
                      <th class="text-right d-none d-md-table-cell">ปกติ</th>
                      <th class="text-right d-none d-md-table-cell">โปรฯ</th>
                      <th class="text-center">จำนวน</th>
                      <th class="text-right d-none d-md-table-cell">รวม</th>
                    </tr>
                    </thead>
                    <tbody class="cart-item">
                    <tr v-for="(item, index) in selectedObject.product_promotions"
                        :key="index"
                        :currentIndex="index"
                        :item="item"
                        class="ItemRow"
                    >
                      <td @click="onClickProduct('S',index)"> {{ item.index_no }}.) {{
                          (item.product ? item.product.nickname : null) ||
                          item.product_code
                        }}
                      </td>
                      <!--<td @click="onClickProduct(index)" class="text-right">{{ number_format(item.price_init)}}</td>-->
                      <td class="text-right d-none d-md-table-cell">
                        {{ $helper.number_format(item.init_price, 2, 2) }}
                      </td>
                      <td class="text-right d-none d-md-table-cell">
                        <v-btn
                            class="delta-text price-text"
                            outlined tile x-small @click="openPriceInVat(item,item.display_price)">
                          {{ $helper.number_format(item.display_price, 2, 2) }}
                        </v-btn>
                      </td>

                      <td class="text-right item-qty">
                        <v-btn :loading="item._save_state==='dirty'" class="delta-button"
                               outlined
                               tile x-small @click="onClickAddCart(item,-1)">
                          <v-icon small>mdi-minus</v-icon>
                        </v-btn>
                        <v-btn class="delta-text delta-qty" outlined tile x-small
                               @click="openQuantity(item,item.quantity)">
              <span class="stock-md">
                {{ $helper.number_format(item.quantity) }} <span
                  style="font-size: 0.7em;font-weight:normal;">{{
                  item.product ? $helper.parseUnit(item.product.unit_primitive) : ''
                }}</span>

              </span>
                        </v-btn>
                        <v-btn :loading="item._save_state==='dirty'" class="delta-button"
                               outlined
                               tile x-small @click="onClickAddCart(item,1)">
                          <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                      </td>
                      <!--<td @click="onClickProduct(index)" class="text-right">{{ number_format(item.total_gross,2,2)}}</td>-->
                      <td class="text-right  d-none d-md-table-cell" @click="onClickProduct('S',index)">{{
                          $helper.number_format(item.display_price * item.quantity, 2, 2)
                        }}
                      </td>

                    </tr>

                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>


            <v-row>
              <v-col>
                <v-btn class="primary add-product"
                       @click.stop="onClickAddItem('S')">เพิ่มสินค้า
                </v-btn>
              </v-col>
              <v-col class="col-2">


              </v-col>
              <v-col>
              </v-col>
              <v-col class="col-3 text-right">
                <div v-if="selectedObject.product_promotions && selectedObject.product_promotions.length>0"
                     class="title">รวม
                  {{ $helper.number_format(selectedObject.total_price, 2, 2) }} บาท
                </div>
              </v-col>
            </v-row>
          </v-container>


          <v-btn class="close-button float-left" color="gray" fab tile @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn class="float-left mt-4 ml-12" color="" plain small text @click="deletingObject()">
            <v-icon x-small>mdi-delete</v-icon>
            ลบโปรโมชั่น
          </v-btn>


          <v-btn :loading="objectLoading" class="close-button float-right" color="primary" fab tile type="submit">
            <v-icon>mdi-check-bold</v-icon>
          </v-btn>
          <v-checkbox
              v-model="selectedObject.enabled"
              class="dialog-input  float-right mr-8"
              label="ใช้งาน"
              outlined
          >
          </v-checkbox>
          <div style="clear: both"></div>
        </v-card>
      </form>
    </v-dialog>

    <v-dialog
        v-model="EditObjectDialogDynamic"
        max-width="900"
        overlay-opacity="0.8"
        persistent
    >
      <form v-if="selectedObject" @submit.prevent="onSubmitObject">
        <v-card class="pa-8">
          <v-container>
            <v-row>
              <v-col>

                <v-text-field
                    v-model="selectedObject.name"
                    class="dialog-input"
                    hide-details
                    label="ชื่อโปรโมชั่น"
                    outlined
                    placeholder=""
                    required
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                    v-model="selectedObject.amount_limit"
                    class="dialog-input"
                    hide-details
                    label="จำกัดจำนวน"
                    outlined
                    placeholder="ไม่จำกัดใส่ 0"
                    required
                >
                </v-text-field>
              </v-col>
            </v-row>


            <v-row>
              <v-col>

                <v-simple-table class="itemTable" fixed-header>
                  <template v-slot:default>
                    <thead>
                    <tr class="ItemHead">
                      <th class="text-left">รายการสินค้าหลัก</th>
                      <th class="text-right d-none d-md-table-cell">ราคา</th>
                      <th class="text-right d-none d-md-table-cell">โปรฯ</th>
                      <th class="text-right d-none d-md-table-cell " style="width:50px"></th>
                    </tr>
                    </thead>
                    <tbody class="cart-item">
                    <tr v-for="(item, index) in selectedObject.product_promotions.filter(i=>i.promotion_type==='D')"
                        :key="index"
                        :currentIndex="index"
                        :item="item"
                        class="ItemRow"
                    >
                      <td @click="onClickProduct('D',index)"> {{ item.index_no }}.) {{
                          (item.product ? item.product.nickname : null) ||
                          item.product_code
                        }}
                      </td>
                      <td class="text-right">{{ $helper.number_format(item.init_price) }}</td>
                      <td class="text-right d-none d-md-table-cell">
                        <v-btn
                            class="delta-text price-text"
                            outlined tile x-small @click="openPriceInVat(item,item.display_price)">
                          {{ $helper.number_format(item.display_price, 2, 2) }}
                        </v-btn>
                      </td>
                      <td class="text-right ">
                        <v-btn :loading="item._save_state==='dirty'" class="delta-button"
                               outlined
                               tile x-small @click="onClickAddCart(item,-item.quantity)">
                          <v-icon small>mdi-minus</v-icon>
                        </v-btn>
                      </td>
                    </tr>

                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>


            <v-row>
              <v-col>
                <v-btn class="primary add-product"
                       @click.stop="onClickAddItem('D')">เพิ่มสินค้าหลัก
                </v-btn>
              </v-col>
              <v-col class="col-8 text-right">
                <div v-for="item in selectedObject.product_promotions.filter(i=>i.promotion_type==='D').slice(0,1)">
                  ครบจำนวน
                  <v-btn :loading="item._save_state==='dirty'" class="delta-button"
                         outlined
                         tile x-small @click="onClickAddCart(item,-1)">
                    <v-icon small>mdi-minus</v-icon>
                  </v-btn>
                  <v-btn class="delta-text delta-qty" outlined tile x-small
                         @click="openQuantity(item,item.quantity)">
                    <span class="stock-md">
                      {{ $helper.number_format(item.quantity) }} <span
                        style="font-size: 0.7em;font-weight:normal;">{{
                        item.product ? $helper.parseUnit(item.product.unit_primitive) : ''
                      }}</span>
                    </span>
                  </v-btn>
                  <v-btn :loading="item._save_state==='dirty'" class="delta-button"
                         outlined
                         tile x-small @click="onClickAddCart(item,1)">
                    <v-icon small>mdi-plus</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col>

                <v-simple-table class="itemTable" fixed-header>
                  <template v-slot:default>
                    <thead>
                    <tr class="ItemHead">

                      <th class="text-left">รายการของแลกแถมเลือกได้ 1 อย่างต่อไปนี้</th>
                      <th class="text-right d-none d-md-table-cell">มูลค่า</th>
                      <!--                      <th class="text-right d-none d-md-table-cell">โปรฯ</th>-->
                      <th class="text-center">จำนวน</th>
                    </tr>
                    </thead>
                    <tbody class="cart-item">
                    <tr v-for="(item, index) in selectedObject.product_promotions.filter(i=>i.promotion_type==='F')"
                        :key="index"
                        :currentIndex="index"
                        :item="item"
                        class="ItemRow"
                    >

                      <td>
                        <v-icon class="pa-1  hover-hilight" v-show="!item.is_child"  small
                                @click="toggleChild(item)"
                        >mdi-format-indent-increase</v-icon>
<!--                        <v-btn v-show="!item.is_child" class="delta-button"-->
<!--                               outlined-->
<!--                               tile x-small @click="toggleChild(item)">-->
<!--                        </v-btn>-->

<!--                        <v-btn v-show="item.is_child" class="delta-button ml-12"-->
<!--                               outlined-->
<!--                               tile x-small @click="toggleChild(item)">-->
<!--                          <v-icon small>mdi-format-indent-decrease</v-icon>-->
<!--                        </v-btn>-->
                        <v-icon class="pa-1 ml-12 hover-hilight" v-show="item.is_child"  small
                                @click="toggleChild(item)"
                        >mdi-format-indent-decrease</v-icon>

                        <span v-show="!item.is_child">{{ item.display_index }}.)</span>



                        {{
                          (item.product ? item.product.nickname : null) ||
                          item.product_code
                        }}
                      </td>
                      <!--<td @click="onClickProduct(index)" class="text-right">{{ number_format(item.price_init)}}</td>-->
                      <td class="text-right d-none d-md-table-cell">
                        {{ $helper.number_format(item.init_price, 2, 2) }}
                      </td>
                      <!--                      <td class="text-right d-none d-md-table-cell">-->
                      <!--                        <v-btn-->
                      <!--                            class="delta-text price-text"-->
                      <!--                            outlined tile x-small @click="openPriceInVat(item,item.display_price)">-->
                      <!--                          {{ $helper.number_format(item.display_price, 2, 2) }}-->
                      <!--                        </v-btn>-->
                      <!--                      </td>-->

                      <td class="text-right item-qty">
                        <v-btn :loading="item._save_state==='dirty'" class="delta-button"
                               outlined
                               tile x-small @click="onClickAddCart(item,-1)">
                          <v-icon small>mdi-minus</v-icon>
                        </v-btn>
                        <v-btn class="delta-text delta-qty" outlined tile x-small
                               @click="openQuantity(item,item.quantity)">
              <span class="stock-md">
                {{ $helper.number_format(item.quantity) }} <span
                  style="font-size: 0.7em;font-weight:normal;">{{
                  item.product ? $helper.parseUnit(item.product.unit_primitive) : ''
                }}</span>

              </span>
                        </v-btn>
                        <v-btn :loading="item._save_state==='dirty'" class="delta-button"
                               outlined
                               tile x-small @click="onClickAddCart(item,1)">
                          <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                      </td>

                    </tr>

                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>


            <v-row>
              <v-col>
                <v-btn class="primary add-product"
                       @click.stop="onClickAddItem('F')">เพิ่มของแลก/แถม
                </v-btn>
              </v-col>
              <v-col class="col-2">


              </v-col>
              <v-col>
              </v-col>
              <v-col class="col-3 text-right">

              </v-col>
            </v-row>


          </v-container>


          <v-btn class="close-button float-left" color="gray" fab tile @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn class="float-left mt-4 ml-12" color="" plain small text @click="deletingObject()">
            <v-icon x-small>mdi-delete</v-icon>
            ลบโปรโมชั่น
          </v-btn>


          <v-btn :loading="objectLoading" class="close-button float-right" color="primary" fab tile type="submit">
            <v-icon>mdi-check-bold</v-icon>
          </v-btn>
          <v-checkbox
              v-model="selectedObject.enabled"
              class="dialog-input  float-right mr-8"
              label="ใช้งาน"
              outlined
          >
          </v-checkbox>
          <div style="clear: both"></div>
        </v-card>
      </form>
    </v-dialog>

    <v-dialog
        v-model="EditObjectDialogDiscount"
        max-width="900"
        overlay-opacity="0.8"
        persistent
    >
      <form v-if="selectedObject" @submit.prevent="onSubmitObject">
        <v-card class="pa-8">
          <v-container>
            <v-row>
              <v-col>

                <v-text-field
                    v-model="selectedObject.name"
                    class="dialog-input"
                    hide-details
                    label="ชื่อโปรโมชั่น"
                    outlined
                    placeholder=""
                    required
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                    v-model="selectedObject.amount_limit"
                    class="dialog-input"
                    hide-details
                    label="จำกัดจำนวน"
                    outlined
                    placeholder="ไม่จำกัดใส่ 0"
                    required
                >
                </v-text-field>
              </v-col>
            </v-row>


            <v-row>
              <v-col>

                <v-simple-table class="itemTable" fixed-header>
                  <template v-slot:default>
                    <thead>
                    <tr class="ItemHead">
                      <th class="text-left">รายการสินค้าหลัก</th>
                      <th class="text-right d-none d-md-table-cell">ราคา</th>
                      <th class="text-right d-none d-md-table-cell " style="width:50px"></th>
                    </tr>
                    </thead>
                    <tbody class="cart-item">
                    <tr v-for="(item, index) in selectedObject.product_promotions.filter(i=>i.promotion_type==='D')"
                        :key="index"
                        :currentIndex="index"
                        :item="item"
                        class="ItemRow"
                    >
                      <td @click="onClickProduct('D',index)"> {{ item.index_no }}.) {{
                          (item.product ? item.product.nickname : null) ||
                          item.product_code
                        }}
                      </td>
                      <!--<td @click="onClickProduct(index)" class="text-right">{{ number_format(item.price_init)}}</td>-->
                      <td class="text-right d-none d-md-table-cell">
                        {{ $helper.number_format(item.init_price, 2, 2) }}
                      </td>
                      <td class="text-right ">
                        <v-btn :loading="item._save_state==='dirty'" class="delta-button"
                               outlined
                               tile x-small @click="onClickAddCart(item,-item.quantity)">
                          <v-icon small>mdi-minus</v-icon>
                        </v-btn>
                      </td>
                    </tr>

                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>


            <v-row>
              <v-col>
                <v-btn class="primary add-product"
                       @click.stop="onClickAddItem('D')">เพิ่มสินค้าหลัก
                </v-btn>
              </v-col>
              <v-col class="col-8 text-right">
                <div v-for="item in selectedObject.product_promotions.filter(i=>i.promotion_type==='D').slice(0,1)">
                  จำนวนตั้งแต่
                  <v-btn :loading="item._save_state==='dirty'" class="delta-button"
                         outlined
                         tile x-small @click="onClickAddCart(item,-1)">
                    <v-icon small>mdi-minus</v-icon>
                  </v-btn>
                  <v-btn class="delta-text delta-qty" outlined tile x-small
                         @click="openQuantity(item,item.quantity)">
                    <span class="stock-md">
                      {{ $helper.number_format(item.quantity) }} <span
                        style="font-size: 0.7em;font-weight:normal;">{{
                        item.product ? $helper.parseUnit(item.product.unit_primitive) : ''
                      }}</span>
                    </span>
                  </v-btn>
                  <v-btn :loading="item._save_state==='dirty'" class="delta-button"
                         outlined
                         tile x-small @click="onClickAddCart(item,1)">
                    <v-icon small>mdi-plus</v-icon>
                  </v-btn>
                  ขึ้นไป
                  รับส่วนลด

                  <v-btn class="delta-text delta-qty" outlined tile x-small
                         @click="openDiscountPercent(selectedObject.discount_percent)">
                    <span class="stock-md">
                      {{ $helper.number_format(selectedObject.discount_percent) }} <span
                        class="percent">%</span>
                    </span>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-container>


          <v-btn class="close-button float-left" color="gray" fab tile @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn class="float-left mt-4 ml-12" color="" plain small text @click="deletingObject()">
            <v-icon x-small>mdi-delete</v-icon>
            ลบโปรโมชั่น
          </v-btn>


          <v-btn :loading="objectLoading" class="close-button float-right" color="primary" fab tile type="submit">
            <v-icon>mdi-check-bold</v-icon>
          </v-btn>
          <v-checkbox
              v-model="selectedObject.enabled"
              class="dialog-input  float-right mr-8"
              label="ใช้งาน"
              outlined
          >
          </v-checkbox>
          <div style="clear: both"></div>
        </v-card>
      </form>
    </v-dialog>


    <v-navigation-drawer
        :width="drawer_width"
        absolute
        class="nav fix-menu"
        permanent
        touchless
    >

      <router-link :to="'/campaigns/'+campaign.price_group" style="text-decoration: none">
        <v-card
            class="pa-2" outlined tile
        >
          &lt;&lt; กลุ่มราคา {{ campaign.price_group }}
        </v-card>
      </router-link>


    </v-navigation-drawer>
    <v-content>
      <v-container
          :style="{
                        paddingLeft:(12+drawer_width)+'px',
                     }"
          child-flex
          class="container"

          fluid>
        <v-card>
          <v-card-title>
            จัดการโปรโมชั่นใน {{ campaign.name }}
            <v-spacer></v-spacer>
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                hide-details
                label="ค้นหา"
                single-line
            ></v-text-field>
          </v-card-title>
          <v-data-table
              v-if="objects && Array.isArray(objects)"
              :headers="[
                        { text: 'รายการ', value: 'name' },
                        { text: 'ชนิด', value: 'promotion_type' , width: '180px', fixed: true ,align: 'center'},
                        { text: 'ราคา', value: 'total_price' , width: '120px', fixed: true ,align: 'right'},
                        { text: 'ใช้งาน', value: 'enabled' , width: '120px', fixed: true, align: 'center'},
                        { text: 'แก้ไข', value: 'edit', width: '120px', fixed: true },
                      ]"
              :items="objects"
              :loading="objectsLoading"
              :search="search"
              class="elevation-1 mb-12 tr-clickable"
              @click:row="editObject"
          >
            <template v-slot:item.total_price="{ item }">
              {{ ['D', 'T'].includes(item.promotion_type) ? '-' : $helper.number_format(item.total_price, 2, 2) }}
            </template>
            <template v-slot:item.edit="{ item }">
              <v-btn class="primary" outlined small @click.stop="editObject(item)">แก้ไข</v-btn>
            </template>
            <template v-slot:item.enabled="{ item }">
              {{ item.enabled ? 'เปิดใช้งาน' : 'ปิด' }}
            </template>
            <template v-slot:item.promotion_type="{ item }">
              {{ item.promotion_type === 'S' ? 'ซื้อเป็นชุด' : '' }}
              {{ item.promotion_type === 'D' ? 'ผสมคละสินค้า' : '' }}
              {{ item.promotion_type === 'T' ? 'ลดราคา' : '' }}
            </template>
          </v-data-table>
          <v-btn absolute

                 bottom
                 class="close-button float-left"
                 color="primary"
                 fab
                 left @click="newObject">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card>


      </v-container>
    </v-content>


  </v-app>
</template>
<style lang="scss" scoped>


.view {
  font-size: 18px;
}

.nav {
  z-index: 1;
}

.container {
  position: relative;
  margin-top: 0;
}

.pad-filter {
  padding: 16px 0 0 24px;
}

.search .v-input__control {
  /*height: 60px;*/
}

.theme--light .list-header-row {
  background: #FFFFFF;
}

.theme--dark .list-header-row {
  background: #000000;
}

.delta-button {
  min-width: 32px !important;
  width: 32px !important;
  height: 32px !important;
  margin: 0 4px 0;
}

.delta-text {
  height: 32px !important;
  font-weight: bold;
  font-size: 16px;
  line-height: 1;
  padding: 0 !important;
  width: 82px;
}

.price-text {
  width: 96px;
  text-align: right;
}

.ItemHead {
  th {
    /*font-size: 16px ;*/
  }
}

.ItemRow {
  td {
    /*font-size: 16px ;*/
  }
}


.stock-sm {
  display: none;
}

@media (max-height: 700px) {
  .data-qty {

  }
  .stock-sm {
    display: block;
    position: absolute;
    top: -5px;
    left: -8px;
    font-weight: normal;
    font-size: 10px;
  }

  .stock-md {
    /*padding-top: 2px;*/
  }
}

.add-product {
  width: 200px;
}

.cart-item, .ItemHead {
  td {
    padding: 0 4px;
  }

  td.item-qty {
    min-width: 170px;
  }

  td:first-child, th:first-child {
    padding-left: 0;
  }

  td:last-child, th:last-child {
    padding-right: 0;
  }
}

.theme--light .primary {
  color: #FFFFFF !important;
}

.discount_percent {
  display: block;
  width: 80px;
  border: #636b6f solid 1px;
  float: right;
  padding-right: 4px;
}
.hover-hilight{
  opacity: 0.5;
}
.hover-hilight:hover{
  opacity: 1;
}
</style>
<script lang="ts">

import {Campaign} from '@/models/Campaign'
import {SimpleResponse} from '@/models/Model'
import {ProductPromotion} from '@/models/ProductPromotion'
import {Promotion} from '@/models/Promotion'
import {DataArray, DataResource} from '@/models/Response'
import {Component, Vue} from 'vue-property-decorator'
import LoadingDummy from '../components/LoadingDummy.vue'
import Helper from '../services/Helper.js'

@Component({
  components: {LoadingDummy},
})
export default class ViewAdminPromotion extends Vue {

  search = ''

  campaign = new Campaign()
  campaign_id = 1

  drawer_ratio = 0.15
  drawer_width = 200

  activeMenu = 'campaign_1'

  show_password = false

  objects: Promotion[] = []

  objectLoading = false
  objectsLoading = false
  selectedObject: Promotion | null = null

  EditObjectDialogStatic = false
  EditObjectDialogDynamic = false
  EditObjectDialogDiscount = false
  EditObjectDialogChooseType = false

  campaign_selector = [
    {text: 'ออนไลน์', value: 1},
    {text: 'หน้าร้าน/เพจ', value: 2},
    {text: 'โปรฯอีสาน', value: 3},
    {text: 'โปรฯหลงจง', value: 4},
    {text: 'โปรฯ TT', value: 5},
    {text: 'โปรฯ PJ', value: 6},
    {text: 'โปรฯ PJ เอกชน', value: 7},
  ]
  lastSearch: string = ''

  async editObject(object: Promotion) {
    this.objectLoading = true

    this.selectedObject = null
    switch (object.promotion_type) {
      case 'S':
        this.EditObjectDialogStatic = true
        break
      case 'D':
        this.EditObjectDialogDynamic = true
        break
      case 'T':
        this.EditObjectDialogDiscount = true
        break
    }
    if (object.id) {
      this.selectedObject = await (new Promotion()).load<Promotion>(object.id)
      let index_no = {'S': 1, 'D': 1, 'F': 1}
      let display_index = {'S': 1, 'D': 1, 'F': 1}
      for (let i in this.selectedObject.product_promotions) {
        const type = this.selectedObject.product_promotions[i].promotion_type
        this.selectedObject.product_promotions[i].index_no = index_no[type]
        this.selectedObject.product_promotions[i].display_index = display_index[type]
        index_no[type]++
        if(!this.selectedObject.product_promotions[i].is_child){
          display_index[type]++
        }
      }
    }

    this.objectLoading = false

  }

  async createObject(type: string): Promise<Promotion> {
    return await new Promise<Promotion>((resolve, reject) => {
      let object = new Promotion()
      object.name = ''
      object.campaign_id = this.campaign_id
      object.price_group = this.campaign.price_group
      object.enabled = true
      object.total_price = 0
      object.product_promotions = []
      object.promotion_type = type
      object.discount_percent = 0
      object.discount_mode = '%'
      resolve(object)
    })
  }

  async newObject() {
    this.EditObjectDialogChooseType = true
  }



  async newObjectType(type: string) {
    this.EditObjectDialogChooseType = false
    this.objectLoading = true
    switch (type) {
      case 'S':
        this.EditObjectDialogStatic = true
        break
      case 'D':
        this.EditObjectDialogDynamic = true
        break
      case 'T':
        this.EditObjectDialogDiscount = true
        break
    }

    this.selectedObject = await this.createObject(type)
    this.objectLoading = false
  }

  cancel() {

    this.EditObjectDialogStatic = false
    this.EditObjectDialogDynamic = false
    this.EditObjectDialogDiscount = false
  }

  async onSubmitObject() {
    this.objectLoading = true
    const isNew = this.selectedObject?.id === null

    this.selectedObject = Object.setPrototypeOf(this.selectedObject, Promotion.prototype)

    if (this.selectedObject) {
      // debugger
      this.recalculateTotal();
      try{
        let object = await this.selectedObject.save<Promotion>()

        this.objectLoading = false

        if (isNew) {
          this.objects.push(object)
        } else {
          for (let i in this.objects) {
            if (this.objects[i].id == object.id) {
              this.objects[i] = object
            }
          }
        }
      }catch (e){
        this.$root.$emit('onError', {error: e})
      }
    }
    this.selectedObject = null
    this.EditObjectDialogStatic = false
    this.EditObjectDialogDynamic = false
    this.EditObjectDialogDiscount = false
  }

  async deletingObject() {
    this.$confirm('ยืนยันลบข้อมูล?').then(res => {
      if (res) {
        this.deleteObject()
      }
    })

  }

  async deleteObject() {
    try {
      if (this.selectedObject == null) return
      this.objectLoading = true

      this.selectedObject = Object.setPrototypeOf(this.selectedObject, Promotion.prototype)

      const response: SimpleResponse = await this.selectedObject?.delete()

      this.objects = this.objects.filter(object => object.id != this.selectedObject?.id)

      this.selectedObject = null
      this.EditObjectDialogStatic = false
      this.EditObjectDialogDynamic = false
      this.EditObjectDialogDiscount = false

      this.$root.$emit('onSuccess', {message: response.toString()})
    } catch (e) {
      console.log(e)
      this.$root.$emit('onError', {error: e})
    }
    this.objectLoading = false
  }

  async mounted() {
    this.drawer_width = Math.max(80, Math.round(window.innerWidth * this.drawer_ratio))
    console.log('window.innerWidth', window.innerWidth)

    if (this.$route.params.id) {
      this.campaign_id = parseInt(this.$route.params.id)
    }

    this.refreshPromotion().then(() => {
    })
  }

  async loadPriceGroup(campaign_id) {
    this.campaign = campaign_id
    this.activeMenu = 'campaign_' + campaign_id
    this.refreshPromotion().then(() => {
    })
  }

  async refreshPromotion() {
    const url_campaign = Helper.setting.campaign.getResourceAPI.replace('{id}', this.campaign_id)

    this.objectsLoading = true
    try {
      if (this.campaign == null || this.campaign_id != this.campaign.id) {
        this.campaign = await Helper.get(url_campaign).then<{ data: DataResource }>(({data}) => data.data)
      }
    } catch (e) {
      alert(e)
    }

    const url_promotion = Helper.setting.promotion.getListAdminAPI + '?campaign=' + this.campaign_id

    try {
      this.objectsLoading = true
      this.objects = await Helper.get(url_promotion).then<{ data: DataArray }>(({data}) => data.data)
    } catch (e) {
      alert(e)
    }

    this.objectsLoading = false
  }

  async openQuantity(item: ProductPromotion, quantity) {
    console.log('$emit', 'openCalculator')
    this.$root.$emit('openCalculator', {
      number: quantity, onApply: async (number) => {
        item.quantity = number
        this.recalculateTotal()
      },
    })
  }

  async openPriceInVat(item: ProductPromotion, price_in_vat) {
    console.log('$emit', 'openCalculator')
    this.$root.$emit('openCalculator', {
      number: price_in_vat, onApply: async (number) => {
        item.display_price = number
        this.recalculateTotal()
      },
    })
  }

  async toggleChild(item: ProductPromotion) {
    console.log('toggle')
    // const that = this
    // item.display_price = item.display_price*1
    item.is_child = !item.is_child
    this.recalculateTotal()
  }

  recalculateTotal() {
    if (this.selectedObject) {
      this.selectedObject.total_price = 0

      let total_pay = 0
      let total_worth = 0
      // debugger;
      let index_no = {'S': 1, 'D': 1, 'F': 1}
      let display_index = {'S': 1, 'D': 1, 'F': 1}
      for (let i in this.selectedObject.product_promotions) {
        const item = this.selectedObject.product_promotions[i]
        const type = item.promotion_type
        item.index_no = index_no[type]
        item.display_index = display_index[type]

        if (type == 'S') {
          if (item.display_price && item.quantity) {
            this.selectedObject.total_price += item.display_price * item.quantity
            total_pay += item.display_price * item.quantity
          }
        }

        if (type == 'D') { // Discount
          if (item.index_no == 1 && item.init_price && item.quantity) {
            if (this.selectedObject.discount_percent === null) {
              this.selectedObject.discount_percent = 0
            }
            // debugger
            this.selectedObject.total_price += item.init_price * item.quantity * this.selectedObject.discount_percent / 100
            total_pay += item.display_price * item.quantity * (1 - this.selectedObject.discount_percent / 100)
            total_worth += item.init_price * item.quantity
          }
        }

        if (type == 'F') { //Free
          if (item.index_no == 1 && item.init_price && item.quantity && index_no[type] == 1) {
            this.selectedObject.total_price += item.init_price * item.quantity
            if (item.display_price) {
              total_pay += item.display_price * item.quantity
            }
            total_worth += item.init_price * item.quantity
          }
        }

        index_no[type]++
        if(!item.is_child){
          display_index[type]++
        }

      }
      if (this.selectedObject.promotion_type == 'D' && total_pay != 0) {
        this.selectedObject.total_price = total_worth - total_pay
        // console.log('Total value ratio', this.selectedObject.total_price)
      }
    }
  }

  async onClickAddItem(type: string) {
    console.log('$emit', 'openProductChooser')
    this.$root.$emit('openProductChooser', {
      price_group: this.selectedObject?.price_group,
      onSearch: async (keyword, response) => {
        this.lastSearch = keyword
      }, keyword: this.lastSearch
      , onApply: async (product) => {
        const item = new ProductPromotion()
        item.product = product
        item.product_id = product.id
        item.quantity = 1
        item.promotion_type = type

        // debugger
        if (this.selectedObject) {
          item.init_price = product['price_' + this.selectedObject.price_group]

          if (type == 'F') {
            item.display_price = 0
          } else {
            item.display_price = item.init_price
          }
          if (this.selectedObject.product_promotions && this.selectedObject.product_promotions.filter(i => i.promotion_type == type).length > 0) {
            item.index_no = this.selectedObject.product_promotions.filter(i => i.promotion_type == type).length + 1
          } else {
            item.index_no = 1
            if (this.selectedObject.product_promotions === null) {
              this.selectedObject.product_promotions = []
            }
          }
          item.promotion_id = this.selectedObject.id
          item.campaign_id = this.selectedObject.campaign_id
          this.selectedObject.product_promotions.push(item)

          console.log(this.selectedObject.product_promotions)
        }

        this.recalculateTotal()
      },
    })
  }

  onClickAddCart(item: ProductPromotion, delta = 1) {
    if (item.quantity) {
      item.quantity += delta
    } else {
      item.quantity = 1
    }
    if (this.selectedObject) {
      if (item.quantity === 0) {
        this.selectedObject.product_promotions = this.selectedObject.product_promotions.filter(pp => pp.index_no != item.index_no || pp.promotion_type != item.promotion_type)
      }
      let index_no = {'S': 1, 'D': 1, 'F': 1}
      for (let i in this.selectedObject.product_promotions) {
        const type = this.selectedObject.product_promotions[i].promotion_type
        this.selectedObject.product_promotions[i].index_no = index_no[type]
        index_no[type]++
      }
      // console.log(this.selectedObject.product_promotions)
      // console.log(index_no)
    }
    this.recalculateTotal()
  }

  async onClickProduct(type: string, index: number) {

  }

  async openDiscountPercent(discount_percent) {
    this.$root.$emit('openCalculator', {
      number: discount_percent, onApply: async (number) => {
        if (this.selectedObject) {
          this.selectedObject.discount_percent = number
          this.selectedObject.discount_mode = '%'
          this.recalculateTotal()
        }
      },
    })
  }


}
</script>
